exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".iframe-component iframe{margin:0;height:100%;width:100%;position:absolute;border:none}@keyframes crossfade-in{0%{opacity:0}to{opacity:1}}@keyframes crossfade-out{0%{opacity:1}to{opacity:0}}@keyframes move-in{0%{left:100%}to{left:0}}@keyframes move-out{0%{left:0}to{left:-100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/Iframe.scss
// module id = 324
// module chunks = 0